import React from 'react'
import { compose } from 'redux'
import { prismicRichTextAsHTML } from 'prismic-utils'
import { withInjectParams } from '../../utils/InjectParams'
import renderEmbedHtml from '../../../lib/embedHtml'
import withStyles from 'constructicon/with-styles'
import styles from './styles'

import BaseRichText from 'constructicon/rich-text'

const RichText = ({
  classNames,
  children,
  injectParams,
  styles,
  ...props
}) => {
  const html = typeof children === 'object'
    ? prismicRichTextAsHTML(children.map(serializeElement), linkResolver)
    : children

  return (
    <BaseRichText styles={styles.root} {...props}>
      {injectParams(html)}
    </BaseRichText>
  )
}

const serializeElement = item => {
  if (item.type === 'embed' && item.oembed) {
    return {
      ...item,
      oembed: {
        ...item.oembed,
        html: renderEmbedHtml(item.oembed)
      }
    }
  }

  return item
}

const linkResolver = link => {
  switch (link.type) {
    case 'custom_site':
      return `https://${link.uid}`
    case 'internal_page':
      return `/${link.slug}`
    default:
      return '#'
  }
}

export default compose(
  withInjectParams,
  withStyles(styles)
)(RichText)
